




























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import FieldArea from "@/models/coding/fieldArea/fieldAreaModel";
@Component
export default class FieldAreaEdit extends GenericEdit<FieldArea> {
  constructor() {
    super();
    this.controller = 'FieldAreas';
    this.model = new FieldArea();
  }
  saveAll(){
      this.model.areaId = this.$route.params.areaId as any;
      return this.validate();
  }
  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }
}
